
import ModelData from "../../../public/model_data";
import ModuleBase from "../../../table/module/poker_table/poker_table_base_module"

import TimeManager from "../../../../manager/time_manager";
import { IUserCurrencyData } from "../../../../manager/user_manager";
import Q2TableViewBase from "./q2_table_view_base";
import Q2TableModelBase from "./q2_table_model_base";
import Q2TableSound from "./q2_table_sound";
import { Q2SeatInfo, Q2RoomInfo } from "./q2_table_data";


const { ccclass } = cc._decorator;

@ccclass
export default class Q2TableModuleBase<V extends Q2TableViewBase, M extends Q2TableModelBase> extends ModuleBase<V, M>  {

    m_lastRefreshTime = 0    
    protected m_isGameInfoInited: boolean = false
    protected m_table_sound: Q2TableSound
    initModule(viewType, modelType, resPath){
        super.initModule(viewType || Q2TableViewBase, modelType || Q2TableModelBase, resPath || 'package/q2/q2_table');
        this.m_table_sound = new Q2TableSound()
    }


    //重置module
    resetModule() {
        super.resetModule() 
        this.m_lastRefreshTime = 0 
    }

    start() {
       super.start()
    }
 
    onInit(intentData: any){
        super.onInit(intentData)                    
    }

    onHide(){
        super.onHide()
    }
    
    onShow(intentData){
        let self = this
        this.resetModule()
        // this.getRemoteRule = function(){
        //     return '{"playerCount":3}'
        // } 
        super.onShow(intentData)
        this.view.setIsGoldTable(true)
        this.view.showSeatInfo(0, Number(ModelData.instance.roleData.id))
        self.getSelfCurrencyData((currencyData: IUserCurrencyData) => {
            let tmp = ModelData.instance.tableCommonData.isClubTable? currencyData.chipClub: currencyData.chip
            !self.m_isGameInfoInited && self.view.showSeatScore(0, true, tmp)
        })
        
        // this.test()
    }

    protected onApplicationShow(isShow) {
        super.onApplicationShow(isShow)
    }

    on_destroy(){
        super.on_destroy()
    }

    genSeatInfo(playerId: number): Q2SeatInfo{
        return new Q2SeatInfo(playerId)
    }

    bindBtnClickEvent(){
        let self = this
        super.bindBtnClickEvent()
    }

    unbindBtnClickEvent(){
        let self = this
        super.unbindBtnClickEvent()
    }

    protected registEventMsg(){     
        super.registEventMsg()   
        this.eventBind("auth_refresh_userinfo", this.refresh_user_info)
    }

    protected unregisstEventMsg(){
        super.unregisstEventMsg()
    }


    update(dt){
        if(this.view){
            if(this.m_lastRefreshTime + 1 < TimeManager.instance.AppRunningTime){
                this.m_lastRefreshTime = TimeManager.instance.AppRunningTime
                this.view.refreshTime(true)
            }            
        }
    }

    refresh_user_info(){
        let roomInfo = this.getRoomInfo() as Q2RoomInfo
        let seatInfoList = roomInfo.seatInfoList
        for (let index = 0; index < seatInfoList.length; index++) {
            const element = seatInfoList[index];
            this.view.showSeatInfo(element.localPos, element.playerId, null, true)
        }
    }

    protected refreshMyCoinBalance(gold: number){
        if(this.getIsGoldTable()){
            let roomInfo = this.getRoomInfo() as Q2RoomInfo
            if(roomInfo){
                this.view.showSeatCoinBalance(0, true, gold)
            }
        }
    }

    protected isMySelf(playerId){
        return playerId == ModelData.instance.roleData.id
    }

    on_click_leave_btn() {        
        super.on_click_leave_btn()
    }

    protected playFightMusic() {
        this.m_table_sound.playBgm()
    }
}